import React from 'react';
import styles from './Dashboard.module.css';

export default function CommentsLog() {
  const mockComments = [
    { id: 1, sub: 'r/SaaS', excerpt: '"I completely agree, transitioning to a microservices architecture..."', upvotes: 142, status: 'Live', date: 'Oct 22, 2026' },
    { id: 2, sub: 'r/startups', excerpt: '"Have you considered trying GrowthBurrow? It really helped our initial..."', upvotes: 45, status: 'Live', date: 'Oct 21, 2026' },
    { id: 3, sub: 'r/Entrepreneur', excerpt: '"The biggest mistake we made in year one was not focusing on customer..."', upvotes: 312, status: 'Live', date: 'Oct 19, 2026' },
    { id: 4, sub: 'r/SideProject', excerpt: '"Check out this new tool we built for finding early users..."', upvotes: 2, status: 'Removed', date: 'Oct 18, 2026' },
  ];

  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>Comments Log</h1>
        <p className={styles.pageSubtitle}>Track the comments placed on your behalf.</p>
      </div>

      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Subreddit</th>
              <th>Excerpt</th>
              <th>Upvotes</th>
              <th>Status</th>
              <th>Date Posted</th>
            </tr>
          </thead>
          <tbody>
            {mockComments.map(c => (
              <tr key={c.id}>
                <td style={{ fontWeight: '500' }}>{c.sub}</td>
                <td style={{ maxWidth: '300px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'var(--text2)' }}>
                  {c.excerpt}
                </td>
                <td style={{ fontWeight: '600' }}>{c.upvotes > 0 ? `+${c.upvotes}` : c.upvotes}</td>
                <td>
                  <span className={`${styles.badge} ${c.status === 'Live' ? styles.badgeGreen : styles.badgeGray}`}>
                    {c.status}
                  </span>
                </td>
                <td>{c.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
